import { Grid, MenuItem, TextField } from '@mui/material'
import { Control, useController, useFormContext } from 'react-hook-form'

import { ControlledTextField } from 'components/common'
import {
  OutOfHoursChargeType,
  OutOfHoursChargeTypeValues,
  TOutOfHoursChargeType,
} from 'constants/index'
import { useGetOutOfHoursChargeRateQuery } from 'generated/graphql'

interface IProps {
  control: Control<any>
}

const OutOfHoursChargeField = ({ control }: IProps) => {
  const { setValue } = useFormContext()

  const { field } = useController({
    control,
    name: 'outOfHoursChargeType',
    defaultValue: OutOfHoursChargeType.Default,
  })

  const { data: defaultRateData } = useGetOutOfHoursChargeRateQuery({
    variables: { customerId: null, consignmentFee: 0 },
    fetchPolicy: 'cache-first',
  })

  const defaultChargeRate = defaultRateData?.outOfHoursChargeRate

  const outOfHoursChargeType: TOutOfHoursChargeType = field.value ?? OutOfHoursChargeType.Default

  const isDefaultCharge = outOfHoursChargeType === OutOfHoursChargeType.Default
  const isPercentage = outOfHoursChargeType === OutOfHoursChargeType.Percent

  const valueName = isPercentage ? 'outOfHoursChargePercent' : 'outOfHoursChargeRate'

  const handleTypeChange = (type: TOutOfHoursChargeType) => {
    field.onChange(type)

    if (type !== OutOfHoursChargeType.Rate) {
      setValue('outOfHoursChargeRate', '', { shouldDirty: true })
    }
    if (type !== OutOfHoursChargeType.Percent) {
      setValue('outOfHoursChargePercent', '', { shouldDirty: true })
    }
  }

  return (
    <>
      <Grid item xs={12} sm={3}>
        <TextField
          select
          fullWidth
          name={field.name}
          inputRef={field.ref}
          label='Out Of Hours Charge'
          value={outOfHoursChargeType}
          onChange={(event) => handleTypeChange(event.target.value as TOutOfHoursChargeType)}
          onBlur={field.onBlur}>
          {OutOfHoursChargeTypeValues.map(({ value, label }) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={3}>
        <ControlledTextField
          key={valueName}
          control={control}
          label={isPercentage ? 'Percentage' : 'Amount'}
          name={valueName}
          defaultValue=''
          type='text'
          inputMode='numeric'
          sanitizedNumber
          disabled={isDefaultCharge}
          placeholder={
            isDefaultCharge && defaultChargeRate != null ? String(defaultChargeRate) : undefined
          }
          startAdornment={isPercentage ? '%' : '£'}
        />
      </Grid>
    </>
  )
}

export default OutOfHoursChargeField
